<h1 mat-dialog-title>{{data.name}}</h1>
<div mat-dialog-content>
  <p>{{data.info}}</p>

</div>
<div mat-dialog-actions>

  <button mat-button [mat-dialog-close]="false" cdkFocusInitial color="accent">Ok</button>
</div>
